import { createHookWithCallbacks } from '@move-frontend/auth';
import { signUpWithCallbacks } from './signUpWithCallbacks';

export const useSignUpWithCallbacks =
	createHookWithCallbacks(signUpWithCallbacks);
